<template>
  <section class="section full-height">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <admin-section-header icon="bell" title="Ajustes" />
    <div class="container columns is-centered">
      <div class="column is-6">
        <div class="section">
          <personal-data-form
            v-model="userPersonalData"
            @input="e => (userPersonalData = e)"
            @formSubmit="callPutUpdateUser"
          />
        </div>
        <div class="section">
          <update-password-form @formSubmit="submitUpdatePassword" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Auth } from 'aws-amplify'
import Fetcher from '@/mixins/fetcher.js'
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import UpdatePasswordForm from '@/components/common/settings/UpdatePasswordForm'
import PersonalDataForm from '@/components/common/settings/PersonalDataForm.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Settings',
  components: { AdminSectionHeader, UpdatePasswordForm, PersonalDataForm },
  mixins: [Fetcher],
  props: {},
  data() {
    return {
      isLoading: false,
      userPersonalData: {}
    }
  },
  computed: {
    ...mapGetters('user', ['personalData', 'userId', 'email'])
  },
  methods: {
    ...mapActions('user', ['putUpdateUser', 'getMyDetails']),
    ...mapMutations('user', ['SET_MY_DETAILS']),
    callPutUpdateUser() {
      let self = this
      const {
        userFirstName: firstName,
        userLastName: lastName,
        city: jobCity,
        country: jobCountry,
        userAvatar: avatarImage,
        ...rest
      } = this.userPersonalData

      const requestData = {
        userData: {
          userId: this.userId,
          email: this.email,
          firstName,
          lastName,
          jobCity,
          jobCountry,
          avatarImage,
          ...rest
        }
      }

      self.request(() =>
        self
          .putUpdateUser({
            userId: this.userId,
            data: requestData
          })
          .then(function() {
            self.getMyDetails().then(userData => {
              self.$store.commit('user/SET_DEFAULT', userData)
              self.$toast.open({
                message: self.$t('Actualizado!'),
                type: 'success'
              })
            })
          })
      )
    },
    submitUpdatePassword(formData) {
      let self = this
      self.isLoading = true
      Auth.currentAuthenticatedUser()
        .then(user => {
          return Auth.changePassword(
            user,
            formData.oldPassword,
            formData.newPassword
          )
        })
        .then(() =>
          self.$toast.open({
            message: self.$t('Contraseña actualizada'),
            type: 'success',
            duration: 5000
          })
        )
        .catch(err =>
          self.$toast.open({
            message: err.message,
            type: 'error',
            duration: 5000
          })
        )
        .then(() => (self.isLoading = false))
    }
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Settings'],
      title: 'Settings'
    })
    this.userPersonalData = this.personalData
  }
}
</script>

<style scoped></style>
